/*
 * @Author: csu chen.su@murata.com
 * @Date: 2022-06-22 15:36:49
 * @LastEditors: csu chen.su@murata.com
 * @LastEditTime: 2022-07-28 10:40:11
 * @FilePath: \frontend\src\layout\mixin\ResizeHandler.js
 */
const { body } = document;
const WIDTH = 992; // refer to Bootstrap's responsive design

const SM_WIDTH = 768;
const MD_WIDTH = 992;
const LG_WIDTH = 1200;
const XL_WIDTH = 1920;

export default {
  watch: {
    $route(route) {
      if (this.device === 'mobile' && this.sidebar.opened) {
        this.$store.dispatch('app/closeSideBar', { withoutAnimation: false });
      }
    },
  },
  beforeMount() {
    window.addEventListener('resize', this.$_resizeHandler);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.$_resizeHandler);
  },
  mounted() {
    this.$_resizeHandler();
    // const isMobile = this.$_isMobile();
    // if (isMobile) {
    //   store.dispatch('app/toggleDevice', 'mobile');
    //   store.dispatch('app/closeSideBar', { withoutAnimation: true });
    // }
  },
  methods: {
    // use $_ for mixins properties
    // https://vuejs.org/v2/style-guide/index.html#Private-property-names-essential
    $_isMobile() {
      const rect = body.getBoundingClientRect();
      return rect.width - 1 < WIDTH;
    },
    $_resizeHandler() {
      if (!document.hidden) {
        const isMobile = this.$_isMobile();
        this.$store.dispatch('app/toggleDevice', isMobile ? 'mobile' : 'desktop');
        if (isMobile) {
          this.$store.dispatch('app/closeSideBar', { withoutAnimation: true });
        }
        const vpWidth = window.innerWidth;
        const vpHeight = window.innerHeight;
        if (vpWidth > XL_WIDTH) {
          this.$store.dispatch('app/setViewport', { breakpoint: 'xl', size: 'large', vpHeight: vpHeight });
        } else if (vpWidth >= LG_WIDTH) {
          this.$store.dispatch('app/setViewport', { breakpoint: 'lg', size: 'large', vpHeight: vpHeight });
        } else if (vpWidth >= MD_WIDTH) {
          this.$store.dispatch('app/setViewport', { breakpoint: 'md', size: 'default', vpHeight: vpHeight });
        } else if (vpWidth >= SM_WIDTH) {
          this.$store.dispatch('app/setViewport', { breakpoint: 'sm', size: 'small', vpHeight: vpHeight });
        } else {
          this.$store.dispatch('app/setViewport', { breakpoint: 'xs', size: 'small', vpHeight: vpHeight });
        }
      }
    },
  },
};
